import instance from "../services/request";
// Key construction (slug + per-upload uniqueness) lives in ONE place so every
// upload surface inherits the collision guarantee — see utils/uploadObjectKey.js
// for the defect this fixes (two uploads of the same filename overwrote each
// other). Capture's AddCaptureModal relies on this to avoid thumbnail collisions.
import { buildUniqueObjectKey } from "./uploadObjectKey";

const API_ENDPOINT = "/api/presigned-url/";

export const getPresignedUrl = async (fileKey, fileSize) => {
  try {
    const response = await instance.post(API_ENDPOINT, {
      object_path: fileKey,
      object_size: fileSize,
    });
    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || "Failed to get pre-signed URL");
    }
  } catch (error) {
    console.error("Error fetching pre-signed URL:", error);
    throw error;
  }
};

export const uploadFile = async (file, folderStructure) => {
  const fileKey = buildUniqueObjectKey(folderStructure, file.name);

  try {
    // Get pre-signed URL from backend
    const { presigned_url, object_url } = await getPresignedUrl(
      fileKey,
      file.size
    );

    // Upload file to S3 via pre-signed URL
    const uploadResponse = await fetch(presigned_url, {
      method: "PUT",
      body: file,
      mode: "cors",
      headers: {
        "x-amz-acl": "public-read",
      },
    });

    if (!uploadResponse.ok) {
      throw new Error(
        `Upload failed: ${uploadResponse.status} ${uploadResponse.statusText}`
      );
    }

    return { location: object_url, fileKey, fileType: file.type };
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};
